<template>
  <div class="modal-overflow">
    <p>
      <i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" />
      <span>
        This will save  <strong>{{ data.assignmentIdsToSave.length }} selected assignments</strong> to the corresponding Ptrac Tasks.
      </span>
    </p>
    <p-checkbox v-model="confirm">I understand this is final and cannot be undone.</p-checkbox>
    <div class="col-md-12 text-center">
      <button :disabled="!confirm" @click="saveAssignmentsToPtrac" class="btn btn-fill btn-wd btn-success">Save</button>
    </div>
    <div class="col-md-12 text-center">
      <button @click="() => this.$emit('close')" class="btn btn-fill btn-info btn-wd">Close</button>
    </div>
  </div>
</template>

<script>
import {notifyError, notifySuccess} from '@/utilities/utils'
import {INTERNAL_SERVER_ERROR, NOT_FOUND, OK} from 'http-status-codes'

export default {
  props: ['data'],
  data() {
    return {
      confirm: false
    }
  },
  methods: {
    async saveAssignmentsToPtrac() {
      const response = await this.$store.dispatch('inspectorRouting/saveAssignmentsToPtrac', this.data.assignmentIdsToSave)
      if (OK === response.status) {
        notifySuccess(this, `${this.data.assignmentIdsToSave.length} inspection assignments saved to PTRAC!`)
      } else if (NOT_FOUND === response.status) {
        notifyError(this, `${this.data.assignmentIdsToSave.length - response.errors.length} assignments saved.
        ${response.errors.length} inspections could not be found:`, response.errors)
      } else if (INTERNAL_SERVER_ERROR === response.status) {
        notifyError(this, `${response.errors.forEach(error => error.message + '\n')}`)
      }
      this.$emit('close')
    }
  }
}
</script>
